import { Smartphone } from 'lucide-react'
import { MSection, SectionHeader } from '@/components/marketing/section'
import { Button } from '@/components/ui/button'
import { MOBILE_APP, type MobileApp } from '@/lib/mobile-app'

// The links to the Android and iOS apps (set in lib/mobile-app.ts). Hidden until at least one is set.
// The app preview video is not here: it plays in the alerts chapter of the story (story.tsx).
export function MobileApps({ app = MOBILE_APP }: { app?: MobileApp }) {
  const { androidUrl, iosUrl } = app
  if (!androidUrl && !iosUrl) return null

  return (
    <MSection id="mobile">
      <div className="max-w-2xl">
        <SectionHeader
          title="Uptrack on your phone"
          lead="Hear about downtime first, then act from the lock screen: acknowledge, escalate or snooze. Alerts reach you by push, phone call, Slack, Discord, Telegram or email."
        />
        <div className="mt-8 flex flex-wrap gap-3">
          {androidUrl && (
            <Button size="lg" className="h-11 px-5 text-[15px]" asChild>
              <a href={androidUrl} target="_blank" rel="noopener noreferrer">
                <Smartphone className="mr-2 h-4 w-4" aria-hidden="true" />
                Android app
              </a>
            </Button>
          )}
          {iosUrl && (
            <Button size="lg" variant={androidUrl ? 'outline' : 'default'} className="h-11 px-5 text-[15px]" asChild>
              <a href={iosUrl} target="_blank" rel="noopener noreferrer">
                <Smartphone className="mr-2 h-4 w-4" aria-hidden="true" />
                iPhone app
              </a>
            </Button>
          )}
        </div>
      </div>
    </MSection>
  )
}
